import { withErrorBoundary } from "@sentry/nextjs";
import { FC, useCallback, useState } from "react";
import styled from "styled-components";
import { Markdown } from "components";
import { Accordion } from "components/Accordion";
import { GeneralRoutingLinkButton } from "components/Molecules/GeneralRoutingLinkButton";
import { Carousel2Content } from "types/graphql/generated";

interface Props {
  className?: string;
  content: Carousel2Content;
}

const Carousel2Mobile: FC<Props> = withErrorBoundary(({ className = "", content: { carousel2Options, title } }) => {
  const [expandedOption, setExpandedOption] = useState("");

  const createHandleChange = useCallback(
    (option: string) => () => {
      setExpandedOption((prevOption) => {
        if (prevOption === option) return "";

        return option;
      });
    },
    []
  );

  return (
    <StyledCarousel2Mobile className={className}>
      <h2 className="Font_40_48_600">{title}</h2>
      <div className="Carousel2__accordion">
        {carousel2Options?.map(({ id, optionName, description, buttonLabel, buttonLink }) => (
          <Accordion
            key={`${id}-${optionName}`}
            title={optionName}
            expanded={optionName === expandedOption}
            onChange={createHandleChange(optionName)}
          >
            <Markdown className="Color_secondary Font_24_32_450 sm:Font_18_26_450">{description}</Markdown>
            {buttonLink && buttonLabel && (
              <GeneralRoutingLinkButton className="Carousel2__button" secondary href={buttonLink}>
                {buttonLabel}
              </GeneralRoutingLinkButton>
            )}
          </Accordion>
        ))}
      </div>
    </StyledCarousel2Mobile>
  );
}, {});

const StyledCarousel2Mobile = styled.div`
  .Carousel2__accordion {
    margin-top: 16px;
  }

  .Carousel2__button {
    width: fit-content;
    margin-top: 16px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    .Carousel2__accordion {
      margin-top: 24px;
    }
  }
`;

export { Carousel2Mobile };
